import script from "./VendorsView.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorsView.vue?vue&type=script&setup=true&lang=js"

import "./VendorsView.vue?vue&type=style&index=0&id=cae47a98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cae47a98"]])

export default __exports__